import { ISpeechAudiogram } from 'gen/ApiClient';

export const calculateBiapImprovement = (aided: ISpeechAudiogram | undefined, unaided: ISpeechAudiogram | undefined) => {
	if (aided === undefined || unaided === undefined) {
		return 0;
	} else {
		return Math.round(aided.biapScore - unaided.biapScore);
	}
};
